/**
 * When `lf_tid` is present in the URL, extracts all query params
 * that are NOT in the provided exclusion set. Returns an empty object
 * if `lf_tid` is not present.
 *
 * Note: `lf_tid` itself IS included in the output — the backend
 * TrackLinkAttribution middleware needs it to record attribution.
 * For duplicate keys, last value wins.
 */
export const extractTrackingQueryParams = (
  searchParams: URLSearchParams,
  internalParams: ReadonlySet<string>
): Record<string, string> => {
  if (!searchParams.has("lf_tid")) {
    return {};
  }

  const trackingParams: Record<string, string> = {};

  for (const [key, value] of searchParams.entries()) {
    if (!internalParams.has(key)) {
      trackingParams[key] = value;
    }
  }

  return trackingParams;
};
